// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"089b433e","833":"73bfcc96"}[chunkId] + ".chunk.js";
};